<template>
    <v-container>
        <module-bar title="REPORTE DE CHOCADOS" icon="mdi-file-chart" />

        <v-row v-if="loadingData">
            <v-col class="d-flex justify-center">
                <v-progress-circular indeterminate color="primary" width="1" size="60" />
            </v-col>
        </v-row>

        <v-row v-if="loadedData">
            <v-col>
                <v-text-field v-model="search" append-icon="mdi-magnify" label="Buscar chocado" single-line hide-details
                    style="max-width: 400px" class="mb-5"></v-text-field>

                <v-card outlined>
                    <v-data-table :search="search" :headers="headers" :items="items" :items-per-page="10"
                        :mobile-breakpoint="800" @click:row="openDialogTool">

                        <template v-slot:[`item.name`]="{ item }">
                            <v-avatar>
                                <v-img :src="item.photo_url" :lazy-src="item.photo_thumb_url" />
                            </v-avatar>
                            {{ item.name }}
                        </template>

                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>

        <v-dialog v-model="dialogCrash" persistent width="800">
            <v-card>
                <v-card-text>
                    <crash-form schema="edit" :crash="crash" :click="click" title="EDITAR CHOCADO"
                        @closeDialogCrash="closeDialogCrash" @deletePhoto="deletePhoto" />
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import ModuleBar from "../../components/General/ModuleBar.vue";
import CrashForm from "../../components/Forms/crashForm.vue";

export default {
    components: {
        ModuleBar,
        CrashForm,
    },

    beforeMount() {
        this.loadingData = true;
        this.loadedData = false;
        setTimeout(() => {
            this.$store.dispatch("findCrashsAction").then((res) => {
                this.items = res;

                this.loadingData = false;
                this.loadedData = true;
            });
        }, 500);
    },

    data() {
        return {
            loadingData: true,
            loadedData: false,
            dialogCrash: false,
            crash: null,
            search: "",
            click: 0,
            headers: [
                {
                    text: "Nombre",
                    value: "name",
                    width: "35%",
                },
                {
                    text: "Informacion",
                    aling: "left",
                    value: "info",
                    width: "30%",
                },
            ],
            items: [],
        };
    },

    methods: {
        openDialogTool(value) {
            this.crash = value;
            this.dialogCrash = true;
            this.click++;
        },

        closeDialogCrash(data) {
            this.dialogCrash = false;
            if (data) {
                let index = this.items.findIndex((v) => v.id == data.crashId);
                if (data.is_delete) {
                    this.items.splice(index, 1);
                    return;
                }
                this.items.splice(index, 1, data.crash);
            }
        },


        deletePhoto({ crashId }) {

            let index = this.items.findIndex((c) => c.id == crashId);
            this.items[index].photo_url = "";
            this.items[index].photo_thumb_url = "";
            this.items[index].photo_short_url = "";
            this.items[index].photo_thumb_short_url = "";
        }

    },
};
</script>
